<template>
  <form role="form" @submit.stop.prevent="">
    <vs-card>
      <div class="vx-row">
        <div class="vx-col w-full mb-2">
          <vs-input
            class="w-full"
            label="Solicitante"
            name="solicitante"
            v-model="form.solicitante"
            v-validate="{ required: true, min: 8 }"
            :state="validateState('Solicitante')"
            :danger="validateClass('solicitante')"
            val-icon-danger="clear"
            danger-text="Informe o nome completo de quem solicita este atendimento"
          />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <label for="" class="vs-select--label">Setor</label>
          <v-select
            :options="setores"
            name="Setor"
            id="Setor"
            v-model="form.idSetor"
            label="nomeSetor"
            class="select-large w-full"
            :reduce="(item) => item.idSetor"
            v-validate="{ required: true }"
            :state="validateState('Setor')"
            :danger="validateClass('Setor')"
          ></v-select>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <label for="" class="vs-select--label">Tipo de Atendimento</label>
          <v-select
            :options="tiposRelacionamento"
            name="Tipo de Atendimento"
            id="Tipo de Atendimento"
            class="select-large w-full"
            v-model="form.idTipoAtendimento"
            label="tipoRelacionamento"
            :reduce="(item) => item.idTipoRelacionamento"
            v-validate="{ required: true }"
            :state="validateState('Tipo de Atendimento')"
            :danger="validateClass('Tipo de Atendimento')"
          ></v-select>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <label for="" class="vs-select--label">Status do Atendimento</label>
          <v-select
            :options="statusRelacionamento"
            name="Status do Atendimento"
            id="Status do Atendimento"
            v-model="form.idStatus"
            label="statusRelacionamento"
            class="select-large w-full"
            :reduce="(item) => item.idStatusRelacionamento"
            v-validate="{ required: true }"
            :state="validateState('Status do Atendimento')"
            :danger="validateClass('Status do Atendimento')"
          ></v-select>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <label for="" class="vs-select--label">Placa / Chassi</label>
          <v-select
            :options="dadosVeiculo"
            name="Placa / Chassi"
            id="Placa / Chassi"
            v-model="form.idVeiculos"
            label="placaChassi"
            class="select-large w-full"
            v-validate="{ required: possuiVeiculos }"
            :reduce="(item) => item.idVeiculo"
            :state="validateState('Placa / Chassi')"
            :danger="validateClass('Placa / Chassi')"
            multiple
          ></v-select>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full mb-2">
          <vs-input
            class="w-full"
            label="Assunto"
            name="Assunto"
            v-model="form.assunto"
            v-validate="{ required: true, min: 8 }"
            :state="validateState('assunto')"
            :danger="validateClass('assunto')"
            val-icon-danger="clear"
            danger-text="Preencha o assunto deste atendimento"
          />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full mb-2">
          <vs-textarea
            label="Descrição"
            name="Descrição"
            v-model="form.descricaoSolicitacao"
            v-validate="{ required: true, min: 20 }"
            :state="validateState('Descrição')"
            :danger="validateClass('Descrição')"
            danger-text="Preencha a descrição"
          />
        </div>
      </div>

      <formAnexarArquivoRelacionamento
        :dadosRelacionamento.sync="dadosRelacionamento"
        :novoAtendimento="true"
        :buscarRelacionamentos="buscarRelacionamentos"
        ref="formRelacionamentoRef"
      >
      </formAnexarArquivoRelacionamento>
      <vs-alert
        v-if="$validator.errors.all().length > 0"
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        <ul>
          <li
            class="mb-2"
            v-for="error in $validator.errors.all()"
            :key="error.id"
          >
            {{ error }}
          </li>
        </ul>
      </vs-alert>

      <div class="vx-row">
        <div class="vx-col w-full text-center">
          <vs-button color="success" type="gradient" @click="onSubmit"
            >Salvar</vs-button
          >
        </div>
      </div>
    </vs-card>
  </form>
</template>
<script>
import service from './../../services';
import locale from './../../locale';
import vSelect from 'vue-select';
import jwt from 'jsonwebtoken';
import formAnexarArquivoRelacionamento from './../forms/FormAnexarArquivoRelacionamento.vue';

export default {
  props: [
    'idAssociado',
    'setores',
    'tiposRelacionamento',
    'statusRelacionamento',
    'dadosVeiculo',
    'idEmpresa',
    'nomeAssociado',
    'buscarRelacionamentos',
    'possuiVeiculos',
  ],
  components: {
    'v-select': vSelect,
    formAnexarArquivoRelacionamento,
  },
  data() {
    return {
      aguardeCadastro: false,
      form: {
        idStatus: null,
        idSetor: null,
        idTipoAtendimento: null,
        solicitante: this.nomeAssociado,
        idVeiculo: null,
        idVeiculos: [],
        assunto: null,
        descricaoSolicitacao: null,
      },
      dadosRelacionamento: {
        idRelacionamento: null,
        idAssociado: null,
        idVeiculos: null,
        idVeiculo: null,
        idUsuario: null,
        ip: null,
        url: null,
      },
    };
  },
  methods: {
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    resetForm() {
      this.form = {
        idStatus: null,
        idSetor: null,
        idTipoAtendimento: null,
        solicitante: null,
        idVeiculo: null,
        idVeiculos: [],
        assunto: null,
        descricaoSolicitacao: null,
      };
      this.dadosRelacionamento = {
        idRelacionamento: null,
        idAssociado: null,
        idVeiculos: null,
        idVeiculo: null,
        idUsuario: null,
        ip: null,
        url: null,
      };

      this.autoFillFields();
    },
    async onSubmit() {
      const newRelacionamento = {
        idEmpresa: this.idEmpresa,
        ...this.form,
        idVeiculos: this.form.idVeiculos.join(','),
      };
      console.log({ newRelacionamento });

      const { idAssociado } = this.$route.params;

      this.$validator.validateAll().then((isValid) => {
        if (!isValid) return;
        this.$vs.loading();
        service
          .post(
            'Relacionamento',
            `inserirAtendimento/${idAssociado}`,
            newRelacionamento,
          )
          .then(({ data }) => {
            // enviando imagem apos inserir atendimento

            this.dadosRelacionamento = {
              idRelacionamento: data.idRelacionamento,
              idAssociado: data.idAssociado,
              idVeiculos: data.idVeiculos,
              idVeiculo: data.idVeiculo,
              idUsuario: data.createdBy,
              ip: null,
              url: null,
            };

            // executa salvar imagem aqui
            this.$refs.formRelacionamentoRef.callOnSubmit(
              this.dadosRelacionamento,
            );

            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Atendimento registrado com sucesso',
              color: 'success',
            });

            this.$emit('concluido');
            this.resetForm();
            this.$vs.loading.close();
          })
          .catch((error) => {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: error,
              color: 'danger',
            });
          });
      });
    },
    autoFillFields() {
      const userToken = localStorage.getItem('user-token');
      const { id_setor } = jwt.decode(userToken);

      // get setor info
      if (id_setor != 13) {
        this.form.idSetor = id_setor;
      }

      // get tipo atendimento info
      const setorData = this.setores.find((setor) => setor.idSetor == id_setor);
      const tipoRelacionamento = this.tiposRelacionamento.find(
        (tipo) =>
          tipo.tipoRelacionamento.replace(' ', '').toUpperCase() ==
          setorData.nomeSetor.replace(' ', '').toUpperCase(),
      );
      if (tipoRelacionamento != undefined) {
        this.form.idTipoAtendimento = tipoRelacionamento.idTipoRelacionamento;
      }

      // auto fill chassi / placa
      if (this.dadosVeiculo.length == 2) {
        this.form.idVeiculos.push(this.dadosVeiculo[1].idVeiculo);
      }
    },
  },
  mounted() {
    this.$validator.localize('ptBr', locale);
    this.autoFillFields();
  },
};
</script>
<style></style>
